import DynamicImage from '@common/components/DynamicImage';
import { type CountryCode, countryCodes } from '@common/utils/device/countryCode';
import '@common/styles/components/flag.pcss';

type FlagProps = {
  language?: never;
  countryCode: CountryCode;
} | {
  language: string;
  countryCode?: never;
};

const flagPathForCountryCode = (countryCode: CountryCode) => (
  `${process.env.PUBLIC_PATH}assets/flags/${countryCode}.svg`
);

const placeholder = (
  <div
    style={{
      width: '24px',
      height: '16px',
      backgroundColor: 'var(--color-gray-8)',
      outline: '1px solid var(--color-gray-16)',
    }}
  />
);

function Flag(props: FlagProps) {
  const countryCode = props.countryCode ?? props.language.split('-')[1] as CountryCode;
  return (
    <span className="flag">
      <DynamicImage
        alt={countryCodes[countryCode]}
        src={flagPathForCountryCode(countryCode)}
        placeholder={placeholder}
        dropShadow
      />
    </span>
  );
}

export default Flag;
